// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"8d8c5c77","96":"9fdfd987","193":"9b5af84d","213":"0b0109b1","453":"1d4465fe","531":"5c180b62","715":"d0cffc4f","859":"f0a7d772","941":"c7ba7eb5","948":"c349a4b1","953":"7bed2e09","986":"65eb829b"}[chunkId] + ".chunk.js";
};